import { closeModal } from "../../../ui/containers/Modal";
import { floodFill, lineDraw } from "../../../ui/helpers";
import { TextType } from "../../../ui/type/TextType";
import { bound, ComponentF, ComponentO, createElement } from "../../../ui/ui";
import { createAction } from "../../actions/Action";
import { wieldWeapon } from "../../actions/ActionItems";
import Colors from "../../Colors";
import { gameData, runPlayerAction } from "../../GameManager";
import { isDownKey, isLeftKey, isRightKey, isUpKey } from "../keyHelper";
import { WeaponDisplay, weaponInfoDraw } from "./wieldable/WeaponDisplay";

const Y_SPLIT = 24;

const getWieldable = () => {
  const player = gameData.player;
  const items = player.contains.filter((i) => i.breed.attacks);
  if (player.wielding.left) {
    items.unshift(player.wielding.left);
  }
  if (player.wielding.right) {
    items.unshift(player.wielding.right);
  }
  return items;
};

export const WieldableModal: ComponentF<{
  title: string;
  keys: string | string[];
  onClick: () => void;
}> = (C, props) => {
  const items = getWieldable();
  const [state, setState] = C.useState({
    selected:
      gameData.player.wielding.left?.id ||
      gameData.player.wielding.right?.id ||
      items[0].id ||
      -1,
    left: gameData.player.wielding.left?.id || -1,
    right: gameData.player.wielding.right?.id || -1,
  });

  floodFill(C.display, C.bounds, Colors.BLACK);
  let y = Y_SPLIT;

  lineDraw(
    C.display,
    bound(C.bounds, { x: 0, y: Y_SPLIT - 1, w: C.bounds.w, h: C.bounds.h }),
    "-"
  );

  const result: ComponentO[] = [];

  const leftItem = state.left && items.find((i) => i.id === state.left);
  const rightItem = state.right && items.find((i) => i.id === state.right);
  result.push(
    createElement(
      WeaponDisplay,
      { x: 0, y: 0, w: C.bounds.w, h: Y_SPLIT - 1 },
      { left: leftItem, right: rightItem }
    )
  );

  items.forEach((item) => {
    if (item.breed.attacks) {
      if (state.selected === item.id) {
        result.push(
          createElement(TextType, { x: 0, y, w: 1, h: 1 }, { title: ">" })
        );
        weaponInfoDraw(
          C.display,
          C.bounds.x + 32,
          C.bounds.y + Y_SPLIT,
          C.bounds.w - 33,
          item
        );
      }
      result.push(
        createElement(
          TextType,
          { x: 1, y, w: 30, h: 1 },
          {
            title: `%c{${
              state.selected === item.id
                ? Colors.B_GREY_5
                : state.left === item.id || state.right === item.id
                ? Colors.RED_4
                : Colors.B_GREY_3
            }}${item.breed.name}${
              state.right === item.id
                ? " (Right Hand)"
                : state.left === item.id
                ? " (Left Hand)"
                : ""
            }`,
          }
        )
      );
      y += 1;
    }
  });

  C.display.drawText(
    C.bounds.x,
    C.bounds.y + C.bounds.h - 2,
    `Use Left & Right to select weapon for that hand`
  );

  C.display.drawText(
    C.bounds.x,
    C.bounds.y + C.bounds.h - 1,
    `%c{${Colors.RED_4}} Enter %c{}Confirm %c{${Colors.RED_4}}Esc%c{} Cancel`
  );

  C.handlers.keypress = (key: string) => {
    if (isUpKey(key)) {
      const idx = items.findIndex((i) => i.id === state.selected);
      if (0 < idx) {
        setState({ selected: items[idx - 1].id });
      }
    } else if (isDownKey(key)) {
      const idx = items.findIndex((i) => i.id === state.selected);
      if (idx < items.length - 1) {
        setState({ selected: items[idx + 1].id });
      }
    } else if (isLeftKey(key)) {
      if (state.left === state.selected) {
        setState({ left: null });
      } else {
        setState({
          left: state.selected,
          right: state.selected === state.right ? null : state.right,
        });
      }
    } else if (isRightKey(key)) {
      if (state.right === state.selected) {
        setState({ right: null });
      } else {
        setState({
          right: state.selected,
          left: state.selected === state.left ? null : state.left,
        });
      }
    } else if (key === "Enter") {
      if (
        state.left !== gameData.player.wielding.left?.id ||
        state.right !== gameData.player.wielding.right?.id
      ) {
        runPlayerAction(
          createAction(wieldWeapon, gameData.player, {
            left: state.left,
            right: state.right,
          })
        );
      }
      closeModal();
      return true;
    } else if (key === "Escape") {
      closeModal();
      return true;
    }
    return true;
  };
  return result;
};
